export const ensureAbsoluteUrl = (href: string): string => {
  if (!href.includes("://") && !href.startsWith("//")) {
    return "//" + href;
  }
  return href;
};
